export function decodeJwt(
  idToken: string,
  atobImpl?: (data: string) => string,
): Record<string, any> {
  const atobFn = atobImpl ?? (typeof atob === 'function' ? atob : (globalThis as any)?.atob);
  if (!atobFn) {
    throw new Error('Base64 decoder (atob) is not available in this environment');
  }

  const base64Url = idToken.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(
    atobFn(base64)
      .split('')
      .map((c: string) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
      .join(''),
  );

  return JSON.parse(jsonPayload);
}
